import React, { useState } from 'react';
import ProductList from './components/ProductList';
import Cart from './components/Cart';
import Hero from './components/Hero';
import Header from './components/Header';
import About from './components/About';
import Appointment from './components/Appointment';
import Footer from './components/Footer';

function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cart, setCart] = useState([]);
  const [legalContent, setLegalContent] = useState(null);

  const addToCart = (product) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.id === product.id);
      if (existingItem) {
        return prevCart.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prevCart, { ...product, quantity: 1 }];
    });
    // On ne force plus l'ouverture ici pour éviter l'erreur visuelle
  };

  const clearCart = () => {
    setCart([]);
  };

  const removeFromCart = (id) => {
    setCart(prevCart => prevCart.filter(item => item.id !== id));
  };

  const updateQuantity = (id, quantity) => {
    if (quantity < 1) {
      removeFromCart(id);
      return;
    }
    setCart(prevCart => prevCart.map(item => item.id === id ? { ...item, quantity } : item));
  };

  const getCartTotal = () => cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  const getCartItemCount = () => cart.reduce((count, item) => count + item.quantity, 0);

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
      <Header setIsCartOpen={setIsCartOpen} getCartItemCount={getCartItemCount} />
      <Hero />
      <main className="container mx-auto px-4 py-12" id="products">
        <ProductList onAddToCart={addToCart}/>
      </main>
      <Appointment />
      <About />
      <Footer setLegalContent={setLegalContent}/>
      {/* Drawer Panier */}
      <div className={`fixed inset-0 z-[100] ${isCartOpen ? 'visible' : 'invisible'}`}>
        <div 
          className={`absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity ${isCartOpen ? 'opacity-100' : 'opacity-0'}`}
          onClick={() => setIsCartOpen(false)}
        />
        <div className={`absolute right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 ${isCartOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <Cart
            cart={cart}
            removeFromCart={removeFromCart}
            updateQuantity={updateQuantity}
            getCartTotal={getCartTotal}
            clearCart={clearCart}
            onClose={() => setIsCartOpen(false)}
          />
        </div>
      </div>
      {legalContent && (
        <div className="fixed inset-0 z-[120] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={() => setLegalContent(null)} />
          <div className="relative bg-white p-8 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl">
            <button onClick={() => setLegalContent(null)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-900">✕</button>
            <div className="prose prose-slate">
              {legalContent === 'mentions' ? (
                <>
                  <h2 className="text-2xl font-bold mb-4">Mentions Légales</h2>
                  <p><strong>Éditeur :</strong> AfroOptic</p>
                  <p><strong>Siège :</strong> Liberte 5, Dakar, Sénégal</p>
                  <p><strong>Hébergement :</strong> Vercel </p>
                </>
              ) : (
                <>
                  <h2 className="text-2xl font-bold mb-4">Politique de Confidentialité</h2>
                  <p>Nous protégeons vos données. Vos informations de livraison ne sont jamais partagées.</p>
                  <p>Paiements sécurisés via Wave Sénégal.</p>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
